<template>
  <path d="M12,12.6,2,4.45h20.1ZM7.45,11.07,1.94,6.6V17.08Zm9.1,0,5.51,6V6.6Zm-1.31,1.06L12,14.76,8.76,12.13,2,19.55H22Z"/>
</template>

<script>
export default {
  name: 'Icon' + 'Email'
};
</script>
